const rgbaToRgb = (color) => {
    if (typeof color !== 'string') return color;
    return color.replace(/^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*[\d.]+\)$/, 'rgb($1, $2, $3)');
};

export const normalizeTextNodesForApi = (textNodes) =>
    textNodes.map(node => {
        if (!Array.isArray(node.val)) return node;
        return {
            ...node,
            val: node.val.map(v => ({
                ...v,
                ...(v.color != null && { color: rgbaToRgb(v.color) }),
                ...(v.highlight != null && { highlight: rgbaToRgb(v.highlight) }),
            })),
        };
    });
